import { GlobeAltIcon, MapPinIcon, PhoneIcon } from '@heroicons/react/24/outline';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { parseRepresentatives } from '../../../../utils/companyDetails';
import RedirectionMapButtons from '../../../common/RedirectionMapButtons';
import type { CompanyInfoBlockProps } from './types';

/** Head office address and FNAIM / SNPI contact of a company page. */
export default function CompanyAddressContactBlock({ details, loading }: CompanyInfoBlockProps) {
  return (
    <div className="mb-4 rounded-lg bg-gray-50 p-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <h3 className="text-md mb-2 flex items-center font-semibold">
            <MapPinIcon className="mr-2 h-5 w-5 text-rgpd-blue-dark" />
            Adresse
          </h3>
          {loading ? (
            <>
              <Skeleton width={200} className="mb-1" />
              <Skeleton width={150} className="mb-1" />
              <div className="flex items-center gap-6">
                <Skeleton width={50} />
                <Skeleton width={50} />
              </div>
            </>
          ) : (
            <>
              <p>{details?.address}</p>
              <p>{details?.postalCode} {details?.city}</p>
              <RedirectionMapButtons
                address={[details?.address, details?.postalCode, details?.city].join(' ')}
                type="circle"
              />
            </>
          )}
        </div>
        <div>
          <h3 className="text-md mb-2 flex items-center font-semibold">
            <PhoneIcon className="mr-2 h-5 w-5 text-rgpd-blue-dark" />
            Contact
          </h3>
          {loading ? (
            <>
              <div className="flex flex-col gap-2">
                <Skeleton width={180} />
                <Skeleton width={180} />
                <Skeleton width={180} />
              </div>
              <Skeleton width={120} className="mt-2" />
            </>
          ) : (
            <>
              {details?.fnaimAdditionalInfo && (
                <div className="mb-2">
                  <p className="font-medium">Représentants légaux :</p>
                  {parseRepresentatives(details.fnaimAdditionalInfo).map((rep, index) => (
                    <p key={index} className="ml-2">• {rep}</p>
                  ))}
                </div>
              )}
              {details?.snpiOwner && !(details?.fnaimAdditionalInfo) && (
                <>
                  <p>Représentants légaux : </p>
                  <p className="ml-2">• {details?.snpiOwner}</p>
                </>
              )}
              <p>Téléphone : {(details?.fnaimPhone != 'N/A' && details?.fnaimPhone) || details?.snpiPhone || 'Inconnu'}</p>
              {(details?.fnaimWebsite || details?.snpiUrl) && (
                <a
                  href={details.fnaimWebsite || details.snpiUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-1 flex items-center text-rgpd-blue hover:text-rgpd-blue-dark"
                >
                  <GlobeAltIcon className="mr-1 h-4 w-4" />
                  {details.fnaimWebsite ? 'Site web FNAIM' : 'Site web SNPI'}
                </a>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
